import styled from 'styled-components';
import Lead from './Lead.mobile';
import QuestionMarkIcon, { QuestionIcon } from '../common/QuestionMarkIcon';

/*
 * Styling
 */
const ManagerWrapper = styled.div`
    padding: 20px 10px;
`;

const ManagerHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

const ManagerHeader = styled.div`
    font-size: 20px;
    color: #949494;
`;

const ManagerLeads = styled.div``;

const ManagerLeadItem = styled(Lead)``;

const LoginWrapper = styled.div`
    display: flex;
    flex-direction: column;
    color: #949494;
    margin: 0 10px auto 10px;
`;

const LoginHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
`;

const LoginTitle = styled.div`
    font-size: 20px;
    color: #949494;
`;

const LoginContainer = styled.div`
    display: flex;
    background-color: #ffffff;
    border: 1px solid #949494;
    border-radius: 3px;
    padding: 10px;
    font-size: 16px;
    align-items: center;
`;

const LoginIcon = styled.div`
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    background-image: url('/img/login-icon-grey.svg');
    background-repeat: no-repeat;
    background-size: contain;
`;

const LoginMainText = styled.div`
    line-height: 20px;
    color: #181818;
    padding-left: 10px;

    a {
        color: #0563c1;
    }
`;

const LoginSubText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 0;
    color: #181818;
    font-size: 16px;
`;

const CtaButtonShowMoreLeadsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    a {
        display: inline-block;
        padding: 10px;
        font-size: 16px;
    }
`;

const InfoIcon = styled(QuestionMarkIcon)`
    ${QuestionIcon} {
        margin-right: 2px;
    }
`;

const ManagerErrorMessage = styled.div``;

const ManagerSubText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    color: #181818;
    font-size: 16px;
`;

export {
    ManagerWrapper,
    ManagerHeaderContainer,
    ManagerHeader,
    ManagerLeads,
    ManagerLeadItem,
    LoginWrapper,
    LoginHeader,
    LoginTitle,
    LoginContainer,
    LoginIcon,
    LoginMainText,
    LoginSubText,
    CtaButtonShowMoreLeadsContainer,
    InfoIcon,
    ManagerErrorMessage,
    ManagerSubText,
};
